<template>
    <div class="settings view">
        <h1>Account Instellingen</h1>
        <div class="settings__wrapper">
            <div class="settings__edit">
                <h3>Bewerk je mailadres</h3>
                <div class="form_control_dubbel">
                    <div class="form_control">
                        <label for="mail">Nieuw mailadres</label>
                        <div class="form_control_icon">
                            <div class="button_2 form_icon_left"><i class="fa-solid fa-envelope"></i></div>
                            <input class="input_icon_left" type="mail" v-model="newMail">
                        </div>
                    </div>
                    <div class="form_control" v-if="newMailStatus == 'current'">
                        <label for="mail" class="settings__false">Bevestig nieuw mailadres</label>
                        <div class="form_control_icon">
                            <div class="button_2 form_icon_left"><i class="fa-solid fa-envelope"></i></div>
                            <input class="input_icon_left" type="mail" style="color: #ff3333" value="Dit mailadres is niet beschikbaar" disabled>
                        </div>
                    </div>
                    <div class="form_control" v-else>
                        <label for="mail" :class="mailCheckClass">Bevestig nieuw mailadres</label>
                        <div class="form_control_icon">
                            <div class="button_2 form_icon_left"><i class="fa-solid fa-envelope"></i></div>
                            <input v-if="newMail.trim() == ''" class="input_icon_left" type="mail" disabled>
                            <input v-else class="input_icon_left" type="mail" v-model="newMailCheck">
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <h3>Bewerk je wachtwoord</h3>
                <div class="form_control_dubbel">
                    <div class="form_control">
                        <label for="password">Nieuw wachtwoord</label>
                        <div class="form_control_icon">
                            <div class="button_2 form_icon_left"><i class="fa-solid fa-lock"></i></div>
                            <input class="input_icon_both" :type="newPassView" v-model="newPass">
                            <div class="button_2 form_icon_right" @click="showNewPass">
                                <i v-if="newPassView === 'password'" class="fa-solid fa-eye-slash"></i>
                                <i v-else class="fa-solid fa-eye"></i>
                            </div>
                        </div>
                    </div>
                    <div class="form_control" v-if="newPassStatus == 'current'">
                        <label for="password" class="settings__false">Bevestig nieuw wachtwoord</label>
                        <div class="form_control_icon">
                            <div class="button_2 form_icon_left"><i class="fa-solid fa-lock"></i></div>
                            <input class="input_icon_both" type="text" style="color: #ff3333" value="Huidig wachtwoord ingegeven" disabled>
                            <div class="button_2 form_icon_right" @click="showNewPassCheck">
                                <i v-if="newPassCheckView === 'password'" class="fa-solid fa-eye-slash"></i>
                                <i v-else class="fa-solid fa-eye"></i>
                            </div>
                        </div>
                    </div>
                    <div class="form_control" v-else>
                        <label for="password" :class="passCheckClass">Bevestig nieuw wachtwoord</label>
                        <div class="form_control_icon">
                            <div class="button_2 form_icon_left"><i class="fa-solid fa-lock"></i></div>
                            <input v-if="newPass.trim() == ''" class="input_icon_both" :type="newPassCheckView" disabled>
                            <input v-else class="input_icon_both" :type="newPassCheckView" v-model="newPassCheck">
                            <div class="button_2 form_icon_right" @click="showNewPassCheck">
                                <i v-if="newPassCheckView === 'password'" class="fa-solid fa-eye-slash"></i>
                                <i v-else class="fa-solid fa-eye"></i>
                            </div>
                        </div>
                    </div>
                </div>
                
                <br>
                <br>
                <h3>Profielfoto</h3>
                <div class="file_input">
                    <div class="form_control">
                        <label for="pass">Upload je nieuwe profielfoto</label>
                        <input type="file" @change="addImage">
                    </div>
                </div>
                <div class="settings__save">
                    <h3>Verificatie</h3>
                    <div class="form_control">
                        <label for="password" :class="oldPassClass">Wachtwoord</label>
                        <div class="form_control_icon">
                            <div class="button_2 form_icon_left"><i class="fa-solid fa-lock"></i></div>
                            <input class="input_icon_both" :type="pass" id="password" name="password" v-model="oldPassCheck" @keyup.enter="saveSettings">
                            <div class="button_2 form_icon_right" @click="showPass">
                                <i v-if="pass === 'password'" class="fa-solid fa-eye-slash"></i>
                                <i v-else class="fa-solid fa-eye"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="settings__preview">
                <div class="settings__preview__img">
                    <img :src="userEdit.img" alt="">
                    <div class="settings__preview__img__delete" @click="deleteImage" v-if="!this.deleteImg">
                        <i class="fa-solid fa-trash"></i>
                    </div>
                </div>
                <div class="settings__preview__text">
                    <h2 >{{ status.userName }}</h2>
                    <p v-if="newMail == ''">{{ status.userMail }}</p>
                    <p v-else>{{ newMail }}</p>
                    <div class="settings__preview__buttons">
                        <router-link to="/" class="button_2">Terug</router-link>
                        <p class="button" @click="saveSettings">Opslaan</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { sha512 } from 'js-sha512';
import  axios  from 'axios';
export default {
    inject:["status", 'user'],
    data(){
        return{
            uploadImg: "",
            deleteImg: false,
            userEdit:{
                name: this.status.userName,
                img: this.status.userImage,
                company: this.status.userCompany,
                pass: this.status.userPass,
            },
            newMail: "",
            newMailStatus: "",
            newPass: "",
            newPassStatus: "",
            oldPassCheck: "",
            newPassCheck: "",
            newMailCheck: "",
            mailCheckClass: "",
            passCheckClass: "",
            oldPassClass: "",
            ready: false,
            mailDuplicate: false,
            passDuplicate: false,
            pass: "password",
            newPassView: "password",
            newPassCheckView: "password"
        }
    },
    methods:{
        showPass(){
            if(this.pass === "password"){
                this.pass = "text";
            } else {
                this.pass = "password"
            }
        },  
        showNewPass(){
            if(this.newPassView === "password"){
                this.newPassView = "text";
            } else {
                this.newPassView = "password"
            }
        },
        showNewPassCheck(){
            if(this.newPassCheckView === "password"){
                this.newPassCheckView = "text";
            } else {
                this.newPassCheckView = "password"
            }
        },
        addImage(event){
            this.uploadImg = event.target.files;
            this.userEdit.img = URL.createObjectURL(event.target.files[0])
            this.deleteImg = false;
        },
        deleteImage(){
            this.userEdit.img = "assets/user.png";
            this.deleteImg = true;
        },
        async saveSettings(){
            if(!this.mailDuplicate && !this.passDuplicate){
                let done = false;
                let changePass = false;
                let password = this.status.userPass;
                let changeMail = false;
                let mail = this.status.userMail;
                let passIsChecked = true;
                let mailIsChecked = true;
                if(!this.ready){
                    this.oldPassClass = "settings__false"
                }

                if(this.ready){
                    if(this.newPass.trim() !== "" && !this.passDuplicate){
                        if(this.newPass === this.newPassCheck){
                            password = sha512(this.newPass + this.status.salted);
                            this.passCheckClass = "";
                            changePass = true;
                            passIsChecked = true
                        } else{
                            this.passCheckClass = "settings__false";
                            passIsChecked = false
                        }
                    }
                    if(this.newMail.trim() !== "" && !this.mailDuplicate){
                        if(this.newMail === this.newMailCheck){
                            mail = this.newMail;
                            this.mailCheckClass = "";
                            changeMail = true;
                            mailIsChecked = true;
                        } else{
                            this.mailCheckClass = "settings__false";
                            mailIsChecked = false;
                        }
                    }
                    let profielfoto = "";
                    let uploadfoto = false;
                    if(this.uploadImg.length == 1){
                        profielfoto = this.uploadImg[0];
                        console.log(profielfoto);
                        uploadfoto = true
                    }
                    if(passIsChecked && mailIsChecked){
                        if(changeMail || changePass || uploadfoto){
                            await axios.post(this.status.api + '/post/edit-account.php', {
                                server: this.status.api,
                                userKey: this.status.userKey,
                                userMail: this.status.userMail,
                                userPass: this.status.userPass,
                                db: this.status.db,
                                id: this.status.userId,
                                newMail: mail,
                                newPass: password,
                                uploadFoto: uploadfoto,
                                foto: profielfoto,
                                deleteFoto: this.deleteImg
                            }, { 
                                headers: {'Content-Type': 'multipart/form-data'}
                            }).then(function (response) {
                                if(response.status == 200){
                                    done = true
                                }
                            }).catch(function (error) {
                                console.error(error);
                            }); 
                        }
                    }
                }
                if(done){
                    if(changePass){
                        this.status.userPass = password;
                        if(localStorage.DevUser){
                            localStorage.removeItem("DevUserPass");
                            localStorage.DevUserPass = this.newPassCheck;
                        } else{
                            sessionStorage.removeItem("DevUserPass");
                            sessionStorage.DevUserPass = this.newPassCheck;
                        }
                    }
                    if(changeMail){
                        this.status.userMail = mail;
                        if(localStorage.DevUser){
                            localStorage.removeItem("DevUserMail");
                            localStorage.DevUserMail = mail;
                        } else{
                            sessionStorage.removeItem("DevUserMail");
                            sessionStorage.DevUserMail = mail;
                        }
                    }
                    this.$router.push("/login")
            }
            }
        }
    },
    watch: {
        user: {
        handler(x){
            if(x.status){
            this.userEdit = {
                name: this.status.userName,
                img: this.status.userImage,
                company: this.status.userCompany,
                pass: this.status.userPass,

            }
            this.oldPassCheck = "";
            this.newPassCheck = "";
            this.newMailCheck = "";
            this.mailCheckClass = "";
            this.passCheckClass = "";
            this.oldPassClass = "";
            this.ready = false
            }
        },
        deep: true
        },
        async newMail(x){
            let data;
            if(x.trim() == ""){
                this.newMailCheck = "";
                this.newMailStatus = "";
                this.mailDuplicate = false;
            } else{
                await axios.get(this.status.api + '/get/account-checker.php',{ 
                    params:{ 
                        userKey: this.status.userKey,
                        userMail: this.status.userMail,
                        userPass: this.status.userPass,
                        db: this.status.db,
                        mail: x
                    }
                    }).then(function(response){
                            data = response.data;          
                    }).catch(function(error){ 
                        console.log(error);
                });
                console.log(data.length);
                if(data.length >= 1){
                    this.newMailStatus = "current";
                    this.mailDuplicate = true;
                } else{
                    this.newMailStatus = "";
                    this.mailDuplicate = false;
                }
            }
        },
        newPass(x){
            if(x.trim() == ''){
                this.newPassCheck = "";
                this.newPassStatus = "";
                this.passDuplicate = false;
            } else{
                if(sha512(x + this.status.salted) == this.status.userPass){
                    this.newPassStatus = "current";
                    this.passDuplicate = true
                } else{
                    this.newPassStatus = "";
                    this.passDuplicate = false;
                }
            }
        },
        newMailCheck(x){
            if(x.trim() == ""){
                this.mailCheckClass = "";
            } else if(x === this.newMail){
                this.mailCheckClass = "";
            } else{
                this.mailCheckClass = "settings__false";
            }
        },
        newPassCheck(x){
            if(x.trim() == ""){
                this.passCheckClass = "";
            } else if(x === this.newPass){
                this.passCheckClass = "";
            } else{
                this.passCheckClass = "settings__false";
            }
        },
        oldPassCheck(x){
            if(x.trim() == ""){
                this.oldPassClass = "";
                this.ready = false;
            } else if(sha512(x + this.status.salted) == this.status.userPass){
                this.oldPassClass = "";
                this.ready = true;
            } else{
                this.oldPassClass = "settings__false";
                this.ready = false;
            }
        }
    }
}
</script>